export const RESERVATION_TYPE = Object.freeze({
  CREATE: 'create',
  UPDATE: 'update',
});
